import * as yup from 'yup';

export const PDFFilesValiadations = yup.object({
  year: yup
    .number()
    .required("Year is required")
});
